import MuiDivider, { DividerProps } from "@mui/material/Divider";

const Divider: React.FC<DividerProps> = MuiDivider;

export default Divider;
export type { DividerProps };
